import { render, staticRenderFns } from "./AddBluesnapAchForm.vue?vue&type=template&id=8b9c0d36&scoped=true"
import script from "./AddBluesnapAchForm.vue?vue&type=script&lang=js"
export * from "./AddBluesnapAchForm.vue?vue&type=script&lang=js"
import style0 from "./AddBluesnapAchForm.vue?vue&type=style&index=0&id=8b9c0d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9c0d36",
  null
  
)

export default component.exports